'use client'

import type { ReactNode } from 'react'
import { cx } from '../utils/cx'
import type { FileKind } from '../FileThumb'

export function Playlist({
  title = 'Playlist',
  children,
  className
}: {
  title?: ReactNode
  children?: ReactNode
  className?: string
}) {
  return (
    <div className={cx('st-playlist', className)}>
      <h3>{title}</h3>
      <div className="st-pl-list">{children}</div>
    </div>
  )
}

interface PlaylistItemProps {
  kind?: FileKind
  num?: ReactNode
  name?: ReactNode
  sub?: ReactNode | ReactNode[]
  selected?: boolean
  commentCount?: number
  playing?: boolean
  pickDisabled?: boolean
  onClick?: () => void
  onPickToggle?: () => void
  className?: string
}

export function PlaylistItem({
  kind = 'video',
  num,
  name,
  sub,
  selected,
  commentCount = 0,
  playing,
  pickDisabled = false,
  onClick,
  onPickToggle,
  className
}: PlaylistItemProps) {
  const subs = Array.isArray(sub) ? sub : sub ? [sub] : []
  return (
    <div className={cx('st-pl-item', playing && 'playing', className)} data-kind={kind} onClick={onClick}>
      <div className="st-pl-num">{num}</div>
      <div style={{ minWidth: 0 }}>
        <div className="st-pl-name">{name}</div>
        <div className="st-pl-sub">
          {subs.map((s, i) => (
            <span key={i}>{s}</span>
          ))}
          {selected && <span className="sel">◆ Picked</span>}
          {commentCount > 0 && (
            <span>
              {commentCount} comment{commentCount === 1 ? '' : 's'}
            </span>
          )}
        </div>
      </div>
      <div className="st-pl-actions">
        <button
          type="button"
          className={cx('ib', selected && 'selected')}
          aria-label={selected ? 'Unpick' : 'Pick'}
          aria-pressed={selected || false}
          disabled={pickDisabled && !selected}
          onClick={(e) => {
            e.stopPropagation()
            onPickToggle?.()
          }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="square">
            <path d="M6 4 L6 22" />
            <path d="M6 4 L18 4 L16 8 L18 12 L6 12" />
          </svg>
        </button>
      </div>
    </div>
  )
}
